/* eslint-disable prettier/prettier */
import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: '',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://drive.google.com/file/d/16kAnPsxCAMKbqvAyvhhFJp5gtNKrW0Df/view', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'p1.PNG',
    title: 'Paw-Five',
    info: 'Paw five is an online platform who works toward saving pets from All over iraq by providing a away in which people who want to adope pets can easily find a pet to adopt from all cities of iraq and kurdistan and people who want to adopt a can add pets to the website to be adopted. tha main goal of this webiste is to rescue homless animals  using ReactJs, Firebase',
    info2: '',
    url: 'https://paw-five.ml/',
    repo: 'https://github.com/Faeza97/capstone-iraq-rct-paw-five', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'p2.PNG',
    title: 'Hotel Booking',
    info: 'Hotel Reservations System are a popular method for booking hotel rooms. Travellers can book rooms on a computer by using online security to protect their privacy and financial information and by using several online travel agents to compare prices and facilities at different hotels. its my Final Research Project for stage 4 using PHP, MySQL, JS, jQuery, and Bootstrap',
    info2: '',
    url: '',
    repo: 'https://github.com/Faeza97/Hotel-Reservation-System/tree/master', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'p3.png',
    title: 'Weather Forecast App',
    info: 'The weather app also provides atmospheric pressure, weather conditions, visibility distance, relative humidity, precipitation in different unites, dew point, wind speed and direction, in addition to ten days in future and hourly weather forecast. It features the basics, including extended forecasts and hourly forecasts developed using ReactJs, axios, API, and React Bootstrap',
    info2: '',
    url: 'https://weatherapp-cpp-team.netlify.app/',
    repo: 'https://github.com/murtaja1/weather_app_js', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'faeza.smohammed@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/Fayzasalman97',
    },
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/faezasalman/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Faeza97',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
